import { render, staticRenderFns } from "./IMSupport.vue?vue&type=template&id=3b3cb278"
import script from "./IMSupport.vue?vue&type=script&lang=js"
export * from "./IMSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports